type BaseButtonProps = {
  text?: string
  iconLeft?: JSX.Element
  iconRight?: JSX.Element
  children?: React.ReactNode
  ref?: React.ForwardedRef<HTMLButtonElement>
}

const BaseButton: React.FC<BaseButtonProps & React.ButtonHTMLAttributes<HTMLButtonElement>> = ({
  onClick,
  disabled,
  ref,
  className,
  text,
  iconLeft,
  iconRight,
  children
}) => {

  return (
    <button
      ref={ref}
      disabled={disabled}
      onClick={onClick}
      className={`button-base ${disabled !== undefined && disabled !== null && disabled ? 'button-disabled' : ''} ${className !== undefined && className}`}
    >
      {iconLeft !== undefined ? <div>{iconLeft}</div> : <></>}
      {text !== undefined && <span>{text}</span>}
      {iconRight !== undefined ? <div>{iconRight}</div> : <></>}
      {children !== undefined && children}
    </button>
  )
}

export default BaseButton
